<template>

  <div>
    <ContentsHeader>
      <template v-slot:title01>{{jobName}}</template>
      <template v-slot:explain01>
株式や社債など証券取引にまつわる商材に携わるのが、証券会社の営業職です。銀行と並んで語られることが多い証券ですが、証券取引の仲介や販売、運用によって利益を得る職業となります。営業職は金融・経済のプロフェッショナルとして、投資家の資産運用に助言するだけの詳細な知識と合理的な説明スキルが求められます。常に市場動向を捉え、一歩先の経済を見通すこの業界の営業職にはどんな人が多いのでしょうか。      </template>
      <template v-slot:yarigai01><span class="ddin">プロとして企業オーナーとのガチンコ真剣勝負が面白い</span><span class="ddin">(石川県 36歳 男性)</span></template>
      <template v-slot:yarigai02><span class="ddin">日々の情報の変化に対応しながらお客様と向き合うこと</span><span class="ddin">(東京都 43歳 男性)</span></template>
      <template v-slot:yarigai03><span class="ddin">大金の運用に関わる責任感が、成果が収入に反映される</span><span class="ddin">(滋賀県 35歳 男性)</span></template>
      <template v-slot:img-headbg><img src="../assets/img/securities/headbg.svg" :alt="jobName" class="img"></template>
      <template v-slot:img-headp><img src="../assets/img/securities/person.svg" :alt="jobName" class="imgp -securities"></template>
    </ContentsHeader>

    <div class="contents-block">

      <section class="job-section">
        <div class="jsinner">
          <div class="block-two -aistretch -jcsb -bptablet">
            <div class="block -b48p -p0">
              <BalanceChartSection :explain="bcExplain" :radarData="radarData"></BalanceChartSection>
            </div>
            <div class="block -b48p -p0">
              <JobChangeRateSection
                :explain="jcExplain"
                :doughnutData="doughnutData"
                :doughnutDataFake="doughnutDataFake"
              ></JobChangeRateSection>
            </div><!-- .block -->
          </div><!-- .block-two -->
        </div><!-- .jsinner -->
      </section>

      <PersonalCharaSection :sevenData="sevenData" :secTtl="'証券業界'" >
        <template v-slot:feature>規律を重視する専門家</template>
        <template v-slot:imgpup><img src="../assets/img/securities/person.svg" alt="不動産業界の営業" class="imgcvperson -securities"></template>
      </PersonalCharaSection>
    
      <div class="lb-area">
        <div class="lbinner block-two -bptablet">
          <div class="block">
            <CareerTypeSection :graphData="graphData" :explain="ctExplain" :jobName="'証券'"></CareerTypeSection>
          </div><!-- .block -->
          <div class=" block">
            <SalesTypeSection :graph2Data="graph2Data" :explain="stExplain" :jobName="'証券'"></SalesTypeSection>
          </div><!-- .block -->
        </div><!-- .block-two -->
      </div><!-- .lb-area -->

      <ResultSection :job="'securities'">
        <template v-slot:jobname>証券業界の営業</template>
        <template v-slot:title01>勤勉で神経質</template>
        <template v-slot:explain01>
          金融業界という括りでは、銀行同様、勤勉な傾向が読み取れます。
          <br />一方で、証券業界では多少心配性な面があることも分かります。
          <br />個人の裁量が大きく、時には顧客にリスクの高い提案をしなければならないからこそ、勤勉さだけでなく、神経質さも一つの素質であると考えられます。
        </template>
        <template v-slot:title02>金融のスペシャリストを目指す</template>
        <template v-slot:explain02>
          スペシャリストになりたいという気持ちが平均的に高く、一方で、安定したキャリアを目指す人の割合は低いことが読み取れます。
          <br />安定した組織に所属することよりも、知識を身につけ専門家として身を立てることに意欲的であると考えられます。
        </template>
        <template v-slot:imgperson><img src="../assets/img/securities/person.svg" alt="不動産業界の営業" class="rsimg"></template>
      </ResultSection>

      <section class="other-section">
        <h2 class="osttl">その他の業界ごとの詳細をのぞく</h2>
        <div class="osinner">
          <DetailsList :job="'securities'"></DetailsList>
        </div><!-- .osinner -->
      </section>

    </div><!-- contents-block -->
  </div>

</template>

<script>
import ContentsHeader from "../components/ContentsHeader.vue";
import ResultSection from "../components/ResultSection.vue";
import DetailsList from "../components/DetailsList.vue";

import BalanceChartSection from "../components/BalanceChartSection.vue";
import JobChangeRateSection from "../components/JobChangeRateSection.vue";
import PersonalCharaSection from "../components/PersonalCharaSection.vue";
import CareerTypeSection from "../components/CareerTypeSection.vue";
import SalesTypeSection from "../components/SalesTypeSection.vue";

export default {
  data() {
    return {
      pageTitle: "証券の営業をのぞく",
      pageURL: "securities",
      pageDescription: "SALES SALES SCOPEでは不動産、保険、ITなど人気10業界の営業職に人物特性と成績に関する調査を実施。株式や社債など証券取引にまつわる商材に携わるのが、証券会社の営業職です。常に市場動向を捉え、一歩先の経済を見通すこの業界の営業職にはどんな人が多いのでしょうか。",

     jobName: "証券の営業",
      bcExplain: "計画性と挑戦意欲に長けている",
      jcExplain: "転職回数はかなり少なめ",
      pcExplain: "規律を重視する専門家",
      ctExplain:
        "困難な課題の解決をのぞむチャレンジャータイプが多く\n安定・保障された身分を望む安定タイプは少ない",
      stExplain:
        "顧客と親密な関係を築こうとするタイプは少なく、何を提案すべきかを重視するタイプが多い",
      radarData: [5.0, 6.1, 6.09, 7.46, 7.08],
      doughnutData: [66, 10, 14, 3, 7],
      doughnutDataFake: [66, 10, 14, 4, 6],
      doughnutData2: [66, 34],
      sevenData: [3, 5, 6, 4, 5, 4, 5],
      graphData: [
        { num: 1, val: 3 },
        { num: 2, val: 7 },
        { num: 3, val: 14 },
        { num: 4, val: 10 },
        { num: 5, val: 17 },
        { num: 6, val: 14 },
        { num: 7, val: 21 },
        { num: 8, val: 14 },
      ],
      graph2Data: [
        { num: 1, val: 4 },
        { num: 2, val: 34 },
        { num: 3, val: 23 },
        { num: 4, val: 9 },
        { num: 5, val: 30 },
      ],
    };
  },
  components: {
    BalanceChartSection,
    JobChangeRateSection,
    PersonalCharaSection,
    CareerTypeSection,
    SalesTypeSection,
    ContentsHeader,
    ResultSection,
    DetailsList
  },
  metaInfo: {
    title: "証券の営業をのぞく | 営業職の特徴を人物特性からのぞいてみた",
    titleTemplate: "%s | SALES SCOPE",
    htmlAttrs: {
      lang: "jp",
    },
  },
  mounted: function(){
    // document.title = title;
    document.querySelector("meta[name='description']").setAttribute('content', this.pageDescription);
    document.querySelector("meta[property='og:title']").setAttribute('content', this.pageTitle + " | 営業職の特徴を人物特性からのぞいてみた | SALES SCOPE");
    document.querySelector("meta[property='og:description']").setAttribute('content', this.pageDescription);
    document.querySelector("meta[property='og:url']").setAttribute('content', 'https://sales-score.jp/scope/' + this.pageURL);
  }
};
</script>